import { Auth, signOut as SignOutFirebase } from 'firebase/auth'

const signOut = (auth: Auth) => {
  return SignOutFirebase(auth)
    .then(() => {
      return { result: true, error: null }
    })
    .catch((err) => {
      return { result: null, error: err }
    })
}

export default signOut
